import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGetMpDtoOrders } from '../../../../actions/admin';
import { TableContainer, Wrapper } from '../ServiceProviders/styled';
import InputWrapper from '../../../common/InputWrapper';
import moment from 'moment';
import useDebounce from '../../../../helpers/hooks/useDebounce';
import Checkbox from './components/checkbox';
import Pagination from '../../../common/Pagination';
import { PER_PAGE_SELECT_OPTIONS } from '../../../../config';
import Button from '../../../common/Button';

const MpDtoOrders = (props) => {
  const { values, handleChangeInput, handleSubmit, setCheckedMpDtoOrders } = props;
  const dispatch = useDispatch();
  const [pageData, setPageData] = useState({
    page: 0,
    size: 15,
    search: '',
  });
  const debouncedSearchTerm = useDebounce(pageData.search, 500);

  useEffect(() => {
    dispatch(
      fetchGetMpDtoOrders({
        page: pageData.page,
        size: pageData.size,
        search: pageData.search,
      }),
    );
  }, [pageData.size, pageData.page, debouncedSearchTerm]);

  const handlePerPageValue = (page) => {
    setPageData({ ...pageData, size: Number(page) });
  };

  const handlePageSelect = (size) => {
    setPageData({ ...pageData, page: Number(size) });
  };

  const handleUpdateMpDtoStatus = (item, index) => {
    handleChangeInput(`mpDtoOrders.${index}.isProcessed`, !item.isProcessed);
    setCheckedMpDtoOrders((prev) => [...prev, !prev.includes(item.id) && item.id]);
  };

  const resetSearchHandler = () => {
    setPageData({ ...pageData, search: '' });
  };

  return (
    <Wrapper>
      {values.mpDtoOrders !== null && (
        <>
          <div className="border-bottom" style={{ marginBottom: '15px' }}>
            <h4 className="header-title">МП DTO Заказы</h4>
          </div>
          <div style={{ padding: '24px 0' }}>
            <div className="row">
              <div className="col-lg-8">
                <InputWrapper
                  noLabel
                  className="form-control search-input"
                  label="Поиск по ID"
                  type="text"
                  placeholder="Поиск"
                  value={pageData.search}
                  onChange={(e) => setPageData({ ...pageData, search: e.target.value })}
                  icon="fe-search"
                />
              </div>
              <div className="col-lg-4">
                <div className="text-lg-right">
                  <Button className="btn" onClick={resetSearchHandler} text="Сбросить поиск" />
                </div>
              </div>
            </div>
          </div>

          <TableContainer>
            <div className="fixed-table-container">
              <div className="fixed-table-body">
                <table className="table table-centered">
                  <thead className="thead-light">
                    <tr>
                      <th>Id</th>
                      <th>Дата создания</th>
                      <th>Название Маркетплейса</th>
                      <th>Тип Маркетплейса</th>
                      <th>isProcessed</th>
                    </tr>
                  </thead>
                  <tbody>
                    {values.mpDtoOrders?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{item.id}</td>
                          <td>{moment(item.createTs).format('D MMMM YYYY H:mm:ss')}</td>
                          <td>{item.marketplace}</td>
                          <td>{item.marketplaceType}</td>
                          <td>
                            <InputWrapper
                              type="checkbox"
                              onChange={() => handleUpdateMpDtoStatus(item, index)}
                              checked={item.isProcessed}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </TableContainer>
          <div className="pagination-wrapper">
            <Pagination
              withPerPageCountSelect
              total={values.mpDtoOrdersTotal}
              currentPage={Number(pageData.page)}
              perPage={Number(pageData.size)}
              onPageSelect={(pageIndex) => handlePageSelect(pageIndex)}
              onPerPageSelect={(perPageValue) => handlePerPageValue(perPageValue)}
              perPageSelectOptions={PER_PAGE_SELECT_OPTIONS}
            />
          </div>
        </>
      )}
    </Wrapper>
  );
};

export default MpDtoOrders;
